import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {TrainingCoursesReport} from 'src/app/shared/Models/TrainingCoursesReport'
@Component({
  selector: 'app-training-courses-report',
  templateUrl: './training-courses-report.component.html',
  styleUrls: ['./training-courses-report.component.css']
})
export class TrainingCoursesReportComponent  {
  ReportsInfo = new TrainingCoursesReport()
  ReceiptBooks: any;
  ReceiptStatus: any;
  constructor(private router: Router) {
  
  }
  ngOnInit(): void {
  }
 
 

  Viewreports() {
  
    localStorage["ReportName"] = "TrainingCoursesReport";
    localStorage.setItem('ReportFilter', JSON.stringify(this.ReportsInfo));

    this.router.navigate([]).then((result) => {
      window.open("/content/admin/reports-service", '_blank');
    });
  }
}
